import { Divider, Link, Stack, Toolbar, Typography } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import { format } from 'date-fns';
import { ConfigService } from '../../services';
import aboutPDF from './about-regulatory-world-map.pdf';
import tosPDF from './tos-regulatory-world-map.pdf';

const Footer = () => {
    return (
        <AppBar color="primary" position="static">
            <Toolbar>
                <Stack direction={'row'} justifyContent={'space-between'} style={{ width: '100%' }}>
                    <Stack direction={'row'} justifyContent={'center'}>
                        <Link href={aboutPDF} target="_blank" color="#FFFFFF">
                            About
                        </Link>
                        <Divider sx={{ border: '1px solid #da1f33', margin: '0 12px' }} orientation="vertical" flexItem />
                        <Link href={tosPDF} target="_blank" color="#FFFFFF">
                            Terms of Use
                        </Link>
                        <Divider sx={{ border: '1px solid #da1f33', margin: '0 12px' }} orientation="vertical" flexItem />
                        <Link href="https://abs.jotform.com/222194343602954" target="_blank" color="#FFFFFF">
                            Give Feedback
                        </Link>

                        <Divider sx={{ border: '1px solid #da1f33', margin: '0 12px' }} orientation="vertical" flexItem />
                        <Typography>{`Copyright © ${format(new Date(), 'yyyy')} by ABS. All rights reserved.`}</Typography>
                    </Stack>

                    <Typography>v{ConfigService.appConfig.lastUpdate}</Typography>
                </Stack>
            </Toolbar>
        </AppBar>
    );
};

export default Footer;
